import { CreateMedicalCenterContainer } from "./containers/MedicalCenters/Create";
import { EditMedicalCenterContainer } from "./containers/MedicalCenters/Edit";
import { MedicalCentersContainer } from "./containers/MedicalCenters/MedicalCenters";
import { Agenda } from "./containers/Agenda/Agenda";
import ClinicalTrialContainer from "./containers/ClinicalTrials/ClinicalTrial";
import ClinicalTrialContainerWrapper from "./containers/ClinicalTrials/ClinicalTrialContainerWrapper";
import General from "./containers/ClinicalTrials/General/General";
import RegulatoryFiles from "./containers/ClinicalTrials/Regulatory/RegulatoryFiles";
import { CreatePatientContainer } from "./containers/Database/CreatePatient";
import { EditPatientContainer } from "./containers/Database/EditPatient";
import { PatientContainer } from "./containers/Database/Patient";
import { ExternalNotesContainer } from "./containers/ExternalNotes/ExternalNotes";
import CreateFreezerContainer from "./containers/Freezers/FreezerComponents/CreateFreezerContainer";
import EditFreezerContainer from "./containers/Freezers/FreezerComponents/EditFreezerContainer";
import FreezersContainer from "./containers/Freezers/FreezerComponents/FreezersContainer";
import CreateIotDeviceContainer from "./containers/Freezers/IotDevicesComponents/CreateDeviceContainer";
import DeviceDetails from "./containers/Freezers/IotDevicesComponents/DeviceDetails";
import IotDevicesContainers from "./containers/Freezers/IotDevicesComponents/IotDevicesContainer";
import CreateEntryContainer from "./containers/MedicalRecords/CreateEntry";
import MedicalRecordContainer from "./containers/MedicalRecords/MedicalRecord";
import { ViewEntryContainer } from "./containers/MedicalRecords/ViewEntry";
import { CreateLaboratoryContainer } from "./containers/Protocols/Admin/CreateLaboratory";
import { CreateStudyTaskContainer } from "./containers/Protocols/Admin/CreateStudyTasks";
import { EditLaboratoryContainer } from "./containers/Protocols/Admin/EditLaboratory";
import { EditStudyTaskContainer } from "./containers/Protocols/Admin/EditStudyTasks";
import { LaboratoriesContainer } from "./containers/Protocols/Admin/Laboratories";
import { StudyTasksContainer } from "./containers/Protocols/Admin/StudyTasks";
import { ExtraForm } from "./containers/Protocols/ExtraForms/ExtraForm";
import ProtocolContainer from "./containers/Protocols/Protocol";
import { Visit } from "./containers/Protocols/Visits/Visit";
import { VisitForm } from "./containers/Protocols/Visits/VisitForm";
import { CreateRoleContainer } from "./containers/Security/Authorization/CreateRole";
import { CreateStudyRoleContainer } from "./containers/Security/Authorization/CreateStudyRole";
import { EditRoleContainer } from "./containers/Security/Authorization/EditRole";
import { EditStudyRoleContainer } from "./containers/Security/Authorization/EditStudyRole";
import { RolesContainer } from "./containers/Security/Authorization/Roles";
import { StudyRolesContainer } from "./containers/Security/Authorization/StudyRoles";
import { CreateTenantContainer } from "./containers/Tenants/Create";
import { EditTenantContainer } from "./containers/Tenants/Edit";
import { TenantsContainer } from "./containers/Tenants/Tenants";
import { CreateUserContainer } from "./containers/Users/CreateUser";
import { EditUserContainer } from "./containers/Users/EditUser";
import { UserContainer } from "./containers/Users/User";
import { UserSettingsContainer } from "./containers/Users/UserSettings";
import { UsersContainer } from "./containers/Users/Users";
import { ClinicalTrialsCreateBriefContainer } from "./views/ClinicalTrials/ClinicalTrialsCreateContainer";
import { ClinicalTrialsView } from "./views/ClinicalTrials/ClinicalTrialsView";
import Dashboard from "./views/Dashboard";
import DatabaseHome from './views/Database';
import ForbiddenPage from "./views/Errors/Forbidden";
import NotFoundPage from "./views/Errors/NotFound";
import UnauthorizedPage from "./views/Errors/Unauthorized";
import { ExtraVisitTrackingView } from "./views/Protocols/ExtraVisitTrackingView";
import { PractitionersView } from "./views/Protocols/PractitionersView";
import { ProtocolCreateView } from "./views/Protocols/ProtocolCreateView";
import { ProtocolEditView } from "./views/Protocols/ProtocolEditView";
import { ProtocolsView } from "./views/Protocols/ProtocolsView";
import { VisitTrackingView } from "./views/Protocols/VisitTrackingView";
import { DeletedVisitView } from "./views/Protocols/DeletedVisitView";
import Settings from "./views/Settings";
import { MemberCreateView, MemberEditView } from "./views/Team/MemberEditView";
import { TeamView } from "./views/Team/TeamView";
import { TelemetryPage } from "./views/TelemetryPage";
import { InventoryPage } from "./views/Inventory";
import UserProfile from "./views/UserProfile";
import PrescriptionReportPage from "./views/PrescriptionReports/PrescriptionReportPage";
import { InventoryManagment } from "./containers/Inventory/Pages/InventoryManagment";
import { AddStockFormPage } from "./containers/Inventory/Pages/AddStockFormPage";
import { MoveDetailPage } from "./containers/Inventory/Pages/MoveDetailPage";
import { AdjustStockFormPage } from "./containers/Inventory/Pages/AdjustStockFormPage";
import { AddStockFormByProtocolPage } from "./containers/Inventory/Pages/AddStockFormByProtocolPage";
import InventoryItemDetailPage from "./containers/Inventory/Pages/InventoryItemDetailPage";
import { AdjustStockFormByProtocolPage } from "./containers/Inventory/Pages/AdjustStockProtocolFormPage";
import ProtocolDispenseRequestForm from "./containers/Protocols/Inventory/ProtocolDispenseRequestForm";
import { ProtocolDispenseConfirmForm } from "./containers/Protocols/Inventory/ProtocolDispenseConfirmForm";
import { ProtocolDispenseDeliverForm } from "./containers/Protocols/Inventory/ProtocolDispenseDeliverForm";
import PharmacyDispensePage from "./containers/Inventory/Pages/PharmacyDispensePage";
import PharmacyDispenseRequestPage from "./containers/Inventory/Pages/PharmacyDispenseRequestPage";
import { PharmacyDispenseConfirmPage } from "./containers/Inventory/Pages/PharmacyDispenseConfirmPage";
import { DispenseMoveDetail } from "./containers/Inventory/Pages/DispenseMoveDetail";
import { DispenseDeliverPage } from "./containers/Inventory/Pages/DispenseDeliverPage";
import { AddStockLaboratoryKitPage } from "./containers/Inventory/Pages/AddStockLaboratoryKitPage";
import { AdjustStockLaboratoryKitFormPage } from "./containers/Inventory/Pages/AdjustStockLaboratoryKitFormPage";
import CreateLaboratoryKitPage from "./containers/Inventory/Pages/CreateLaboratoryKitPage";
import CreateProtocolItemPage from "./containers/Inventory/Pages/CreateProtocolItemPage";
import LaboratoryKitDispenseForm from "./containers/Protocols/LaboratoryKit/LaboratoryKitDispenseForm";
import LaboratoryKitDispenseDeliverForm from "./containers/Protocols/LaboratoryKit/LaboratoryKitDispenseDeliverForm";

const routes = [
  {
    path: "/dashboard",
    name: "routes.dashboard",
    iconSVG: "dashboard",
    component: Dashboard,
    layout: "/admin"
  },
  // Agenda
  {
    path: "/agenda",
    name: "routes.agenda",
    iconSVG: "agenda",
    component: Agenda,
    layout: "/admin",
    permission: ["Agenda.List"],
  },
  // Patients
  {
    collapse: true,
    displayChilds: false,
    path: "/database",
    name: "routes.database",
    iconSVG: "patients",
    layout: "/admin",
    permission: ["Database.List"],
    component: DatabaseHome,
    routes: [
      {
        path: "/database",
        name: "Pacientes",
        mini: "P",
        layout: "/admin",
        component: DatabaseHome,
        hidden: true
      },
      {
        path: "/database/create",
        name: "Nuevo Paciente",
        mini: "NP",
        layout: "/admin",
        component: CreatePatientContainer,
        hidden: true
      },
      {
        path: "/database/:medicalRecordNumber",
        name: "Ver Paciente",
        mini: "VP",
        layout: "/admin",
        component: PatientContainer,
        hidden: true
      },
      {
        path: "/database/:medicalRecordNumber/edit",
        name: "Editar Paciente",
        mini: "EP",
        layout: "/admin",
        component: EditPatientContainer,
        hidden: true
      },
    ]
  },
  // Medical Records
  {
    collapse: true,
    displayChilds: false,
    path: "/medicalRecords",
    name: "routes.medicalRecords",
    iconSVG: "medicalRecords",
    component: MedicalRecordContainer,
    layout: "/admin",
    permission: ["MedicalRecords.List"],
    hidden: true,
    routes: [
      {
        path: "/medicalRecords/:medicalRecordNumber",
        name: "Historia Clínica",
        mini: "HC",
        layout: "/admin",
        component: MedicalRecordContainer,
        hidden: true
      },
      {
        path: "/medicalRecords/:medicalRecordNumber/newentry/:entryId",
        name: "Nueva Entrada",
        mini: "NE",
        layout: "/admin",
        component: CreateEntryContainer,
        hidden: true
      },
      {
        path: "/medicalRecords/:medicalRecordNumber/entry/:entryId",
        name: "Entrada",
        mini: "VE",
        layout: "/admin",
        component: ViewEntryContainer,
        hidden: true
      }
    ]
  },
  //Clinical Trials
  {
    collapse: true,
    displayChilds: false,
    path: "/clinicalTrials",
    name: "routes.clinicalTrials",
    iconSVG: "clinical-trials",
    layout: "/admin",
    name: "Ensayos Clínicos",
    permission: ["Startups.List"],
    routes: [
      //clinical trials
      {
        path: "/clinicalTrials",
        name: "Ensayos Clínicos",
        mini: "E",
        layout: "/admin",
        component: ClinicalTrialsView,
        hidden: false
      },
      {
        path: "/clinicalTrials/create",
        name: "Nuevo Ensayo Clínicos",
        mini: "NEC",
        layout: "/admin",
        component: ClinicalTrialsCreateBriefContainer,
        hidden: false
      },
      {
        path: "/clinicalTrials/edit/:id",
        name: "Modificar ensayo clinico",
        mini: "E",
        layout: "/admin",
        component: ClinicalTrialContainerWrapper,
        hidden: false
      },
      //teams
      {
        path: "/clinicalTrials/team",
        name: "Equipo",
        mini: "E",
        layout: "/admin",
        component: TeamView,
        hidden: false
      },
      {
        path: "/clinicalTrials/team/edit/:id",
        name: "Información",
        mini: "E",
        layout: "/admin",
        component: MemberEditView,
        hidden: false
      },
      {
        path: "/clinicalTrials/regulatory/:id",
        name: "Regulatorio",
        mini: "E",
        layout: "/admin",
        component: RegulatoryFiles,
        hidden: false
      }
    ]
  },
  // Protocols
  {
    collapse: true,
    displayChilds: false,
    path: "/protocols",
    name: "routes.protocols",
    iconSVG: "protocols",
    layout: "/admin",
    permission: ["Protocols.List"],
    routes: [
      {
        path: "/protocols",
        name: "Protocolos",
        mini: "P",
        layout: "/admin",
        component: ProtocolsView,
        hidden: false
      },
      {
        path: "/protocols/create",
        name: "Nuevo Protocolo",
        mini: "NP",
        layout: "/admin",
        component: ProtocolCreateView,
        hidden: true
      },
      {
        path: "/protocols/:protocolId",
        name: "Protocolo",
        mini: "P",
        layout: "/admin",
        component: ProtocolContainer,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/section/:section",
        mini: "P",
        layout: "/admin",
        component: ProtocolContainer,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/edit/",
        name: "Editar Protocolo",
        mini: "EP",
        layout: "/admin",
        component: ProtocolEditView,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/practitioners",
        name: "Profesionales",
        mini: "AP",
        layout: "/admin",
        component: PractitionersView,
        hidden: true
      },
      // visitTracking
      {
        path: "/protocols/:protocolId/deletedVisit/:logId",
        name: "Visita Eliminada",
        mini: "VE",
        layout: "/admin",
        component: DeletedVisitView,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/visitTracking/:visitId/patient/:patientId",
        name: "Visita Protocolar",
        mini: "VP",
        layout: "/admin",
        component: VisitTrackingView,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/visitTrackingExtra/:visitId/patient/:patientId",
        name: "Visita No Programada",
        mini: "VEP",
        layout: "/admin",
        component: ExtraVisitTrackingView,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/visitsTemplate/:visitId",
        name: "Hoja de Visita",
        mini: "VP",
        layout: "/admin",
        component: Visit,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/visitsTemplate/:visitId/forms/create",
        name: "Crear formulario para hoja de visita",
        mini: "VP",
        layout: "/admin",
        component: VisitForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/visitsTemplate/:visitId/forms/:formId",
        name: "Editar formulario para hoja de visita",
        mini: "VP",
        layout: "/admin",
        component: VisitForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/extraforms/create/:extraformtype",
        name: "Crear formulario extra",
        mini: "EF",
        layout: "/admin",
        component: ExtraForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/extraforms/:formId",
        name: "Editar formulario extra",
        mini: "EEF",
        layout: "/admin",
        component: ExtraForm,
        hidden: true
      },
      // Inventory
      {
        path: "/protocols/:protocolId/inventory/request/:protocolId",
        name: "Protocol dispense request",
        mini: "PDR",
        layout: "/admin",
        component: ProtocolDispenseRequestForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/inventory/:dispenseId/confirm",
        name: "Protocol dispense confirm",
        mini: "PDC",
        layout: "/admin",
        component: ProtocolDispenseConfirmForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/inventory/:dispenseId/deliver",
        name: "Protocol dispense deliver",
        mini: "PDC",
        layout: "/admin",
        component: ProtocolDispenseDeliverForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/inventory/:dispenseId/detail",
        name: "Protocol dispense detail",
        mini: "PDC",
        layout: "/admin",
        component: DispenseMoveDetail,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/laboratorykit/request",
        name: "Laboratory KIT dispense",
        mini: "PDR",
        layout: "/admin",
        component: LaboratoryKitDispenseForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/laboratorykit/:dispenseId/deliver",
        name: "Laboratory KIT dispense deliver",
        mini: "PDR",
        layout: "/admin",
        component: LaboratoryKitDispenseDeliverForm,
        hidden: true
      },
      {
        path: "/protocols/:protocolId/laboratorykit/:dispenseId/detail",
        name: "Laboratory KIT dispense detail",
        mini: "PDC",
        layout: "/admin",
        component: DispenseMoveDetail,
        hidden: true
      },
    ]
  },
  // External Notes
  {
    path: "/externalnotes",
    name: "routes.externalnotes",
    iconSVG: "externalnote",
    layout: "/admin",
    permission: ["Protocols.List"],
    component: ExternalNotesContainer,
  },
  // Inventory
  {
    path: "/inventory",
    collapse: true,
    state: "active",
    name: "routes.inventory",
    layout: "/admin",
    iconSVG: "inventory",
    permission: ["GeneralInventory.View", "ProtocolInventory.View"],
    routes: [
      {
        path: "/inventory",
        name: "Movimientos",
        mini: "ETP",
        layout: "/admin",
        component: InventoryManagment,
        permission: ["GeneralInventory.View", "ProtocolInventory.View"],
        hidden: true
      },
      {
        path: "/inventory/section/:section",
        name: "Movimientos",
        mini: "ETP",
        layout: "/admin",
        component: InventoryManagment,
        permission: ["GeneralInventory.View", "ProtocolInventory.View"],
        hidden: true
      },
      {
        path: "/inventory/items/protocol/create",
        name: "Crear medicación",
        mini: "ETP",
        layout: "/admin",
        component: CreateProtocolItemPage,
        permission: ["ProtocolInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/items/protocol/:itemId/edit",
        name: "Editar medicación",
        mini: "ETP",
        layout: "/admin",
        component: CreateProtocolItemPage,
        permission: ["ProtocolInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/items/:origin/:itemId",
        name: "Detalle de item",
        mini: "ETP",
        layout: "/admin",
        component: InventoryItemDetailPage,
        permission: ["GeneralInventory.View", "ProtocolInventory.View", "LaboratoryKitInventory.View"],
      },
      {
        path: "/inventory/moves/:moveId",
        name: "Detalle de movimientos",
        mini: "ETP",
        layout: "/admin",
        component: MoveDetailPage,
        permission: ["GeneralInventory.View", "ProtocolInventory.View"],
        hidden: true
      },
      {
        path: "/inventory/addstock/:moveId",
        name: "Agregar Stock",
        mini: "ETP",
        layout: "/admin",
        component: AddStockFormPage,
        permission: ["GeneralInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/protocol/addstock/:moveId",
        name: "Agregar Stock",
        mini: "ETP",
        layout: "/admin",
        component: AddStockFormByProtocolPage,
        permission: ["ProtocolInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/laboratorykit/addstock/:moveId",
        name: "Agregar Stock",
        mini: "ETP",
        layout: "/admin",
        component: AddStockLaboratoryKitPage,
        permission: ["LaboratoryKitInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/adjuststock/:moveId",
        name: "Ajustar Stock",
        mini: "ETP",
        layout: "/admin",
        component: AdjustStockFormPage,
        permission: ["GeneralInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/protocol/adjuststock/:moveId",
        name: "Ajustar Stock",
        mini: "ETP",
        layout: "/admin",
        component: AdjustStockFormByProtocolPage,
        permission: ["ProtocolInventory.View"],
        hidden: true
      },
      {
        path: "/inventory/laboratorykit/adjuststock/:moveId",
        name: "Ajustar Stock",
        mini: "ETP",
        layout: "/admin",
        component: AdjustStockLaboratoryKitFormPage,
        permission: ["LaboratoryKitInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/laboratorykit/edit/:itemId",
        name: "Editar Kit de laboratorio",
        mini: "ETP",
        layout: "/admin",
        component: CreateLaboratoryKitPage,
        permission: ["LaboratoryKitInventory.Edit"],
        hidden: true
      },
      {
        path: "/inventory/pharmacy/dispense",
        name: "Dispensa de Farmacia",
        mini: "ETP",
        layout: "/admin",
        component: PharmacyDispensePage,
        permission: ["GeneralInventory.Create"],
        hidden: true
      },
      {
        path: "/inventory/pharmacy/request",
        name: "Solicitud de Farmacia",
        mini: "ETP",
        layout: "/admin",
        component: PharmacyDispenseRequestPage,
        permission: ["GeneralInventory.Request"],
        hidden: true
      },
      {
        path: "/inventory/pharmacy/:dispenseId/confirm",
        name: "Solicitud de Farmacia",
        mini: "ETP",
        layout: "/admin",
        component: PharmacyDispenseConfirmPage,
        permission: ["GeneralInventory.Deliver"],
        hidden: true
      },
      {
        path: "/inventory/dispense/:dispenseId/deliver",
        name: "Solicitud de Farmacia",
        mini: "ETP",
        layout: "/admin",
        component: DispenseDeliverPage,
        permission: ["GeneralInventory.Deliver", "Inventory.Deliver"],
        hidden: true
      },
      {
        path: "/inventory/pharmacy/:dispenseId/detail",
        name: "Detalle de Movimiento",
        mini: "ETP",
        layout: "/admin",
        component: DispenseMoveDetail,
        permission: ["GeneralInventory.View"],
        hidden: true
      },
    ],
    component: InventoryPage
  },
  // Settings
  {
    collapse: true,
    path: "/settings",
    name: "routes.settings",
    state: "active",
    layout: "/admin",
    iconSVG: "settings",
    permission: ["Security.List", "Settings.List"],
    routes: [
      // Tenants
      {
        path: "/tenant",
        name: "Clientes",
        mini: "CL",
        layout: "/admin",
        component: TenantsContainer,
        permission: ["Tenant.List"],
        hidden: true
      },
      {
        path: "/tenant/create",
        name: "Crear Cliente",
        mini: "CLC",
        layout: "/admin",
        component: CreateTenantContainer,
        hidden: true
      },
      {
        path: "/tenant/:tenantId",
        name: "Editar Cliente",
        mini: "CLE",
        layout: "/admin",
        component: EditTenantContainer,
        hidden: true
      },
      // Medical Centers
      {
        path: "/settings/medicalcenters",
        name: "Centros",
        mini: "CE",
        layout: "/admin",
        component: MedicalCentersContainer,
        permission: ["MedicalCenter.List"],
        hidden: true
      },
      {
        path: "/settings/medicalcenters/create",
        name: "Crear Centro",
        mini: "CCE",
        layout: "/admin",
        component: CreateMedicalCenterContainer,
        permission: ["MedicalCenter.Create"],
        hidden: true
      },
      {
        path: "/settings/medicalcenters/:medicalCenterId",
        name: "Editar Centro",
        mini: "ECE",
        layout: "/admin",
        component: EditMedicalCenterContainer,
        permission: ["MedicalCenter.Edit"],
        hidden: true
      },

      {
        permission: ["Security.List", "Settings.List"],
        path: "/settings",
        name: "Configuración",
        mini: "C",
        layout: "/admin",
        component: Settings,
        hidden: true
      },
      {
        permission: ["Users.List"],
        path: "/users",
        name: "Usuarios",
        mini: "U",
        layout: "/admin",
        component: UsersContainer,
        hidden: true
      },
      {
        permission: ["Users.Create"],
        path: "/users/create",
        name: "Nuevo Usuario",
        mini: "NP",
        layout: "/admin",
        component: CreateUserContainer,
        hidden: true
      },
      {
        permission: ["Users.View"],
        path: "/users/:userId",
        name: "Usuario",
        mini: "VP",
        layout: "/admin",
        component: UserContainer,
        hidden: true
      },
      {
        permission: ["Users.Edit"],
        path: "/users/:userId/edit",
        name: "Editar",
        mini: "EP",
        layout: "/admin",
        component: EditUserContainer,
        hidden: true
      },
      {
        permission: ["Users.Edit"],
        path: "/users/:userId/completeProfile",
        name: "Perfíl de usuario",
        mini: "EP",
        layout: "/admin",
        component: UserProfile,
        hidden: true
      },
      {
        permission: ["Users.Edit"],
        path: "/users/:userId/config",
        name: "Configurar",
        mini: "C",
        layout: "/admin",
        component: UserSettingsContainer,
        hidden: true
      },
      {
        path: "/settings/roles",
        name: "Roles",
        mini: "R",
        layout: "/admin",
        component: RolesContainer,
        permission: ["Security.List"],
        hidden: true
      },
      {
        path: "/settings/roles/create",
        name: "Crear Rol",
        mini: "CR",
        layout: "/admin",
        component: CreateRoleContainer,
        hidden: true
      },
      {
        path: "/settings/roles/:roleId",
        name: "Editar Rol",
        mini: "ER",
        layout: "/admin",
        component: EditRoleContainer,
        hidden: true
      },
      // StudyRoles
      {
        path: "/settings/studyRoles",
        name: "Roles del Protocolo",
        mini: "RP",
        layout: "/admin",
        component: StudyRolesContainer,
        permission: ["Security.List"],
        hidden: true
      },
      {
        path: "/settings/studyRoles/create",
        name: "Crear Rol",
        mini: "CRP",
        layout: "/admin",
        component: CreateStudyRoleContainer,
        hidden: true
      },
      {
        path: "/settings/studyRoles/:roleId",
        name: "Editar Rol",
        mini: "ERP",
        layout: "/admin",
        component: EditStudyRoleContainer,
        hidden: true
      },
      // StudyTasks
      {
        path: "/settings/studyTasks",
        name: "Tareas del Protocolo",
        mini: "TP",
        layout: "/admin",
        component: StudyTasksContainer,
        permission: ["Settings.List"],
        hidden: true
      },
      {
        path: "/settings/studyTasks/create",
        name: "Crear Tarea Protocolar",
        mini: "CTP",
        layout: "/admin",
        component: CreateStudyTaskContainer,
        hidden: true
      },
      {
        path: "/settings/studyTasks/:studyTaskId",
        name: "Editar Tarea Protocolar",
        mini: "ETP",
        layout: "/admin",
        component: EditStudyTaskContainer,
        hidden: true
      },

      // Laboratories
      {
        path: "/settings/laboratories",
        name: "Laboratorios",
        mini: "TP",
        layout: "/admin",
        component: LaboratoriesContainer,
        permission: ["Settings.List"],
        hidden: true
      },
      {
        path: "/settings/laboratories/create",
        name: "Crear Laboratorio",
        mini: "CTP",
        layout: "/admin",
        component: CreateLaboratoryContainer,
        hidden: true
      },
      {
        path: "/settings/laboratories/:laboratoryId",
        name: "Editar Laboratorio",
        mini: "ETP",
        layout: "/admin",
        component: EditLaboratoryContainer,
        hidden: true
      },
      // Freezers
      {
        path: "/settings/freezers",
        name: "Heladeras",
        mini: "TP",
        layout: "/admin",
        component: FreezersContainer,
        permission: ["Freezers.List"],
        hidden: true
      },
      {
        path: "/settings/freezers/create",
        name: "Crear Heladera",
        mini: "CTP",
        layout: "/admin",
        component: CreateFreezerContainer,
        permission: ["Freezers.Create"],
        hidden: true
      },
      {
        path: "/settings/freezers/:freezerId",
        name: "Editar Heladera",
        mini: "ETP",
        layout: "/admin",
        component: EditFreezerContainer,
        permission: ["Freezers.Edit"],
        hidden: true
      },
      //Devices
      {
        path: "/settings/devices",
        name: "Dispositivos",
        mini: "TP",
        layout: "/admin",
        component: IotDevicesContainers,
        permission: ["Devices.List"],
        hidden: true
      },
      {
        path: "/settings/devices/create",
        name: "Crear Dispositivo",
        mini: "CTP",
        layout: "/admin",
        component: CreateIotDeviceContainer,
        permission: ["Devices.Create"],
        hidden: true
      },
      {
        path: "/settings/devices/detail/:deviceId",
        name: "Editar Dispositivo",
        mini: "ETP",
        layout: "/admin",
        component: DeviceDetails,
        permission: ["Devices.Edit"],
        hidden: true
      },
      //Telemetry
      {
        path: "/devicetelemetry",
        name: "Telemetria",
        mini: "T",
        layout: "/admin",
        component: TelemetryPage,
        permission: ["Telemetry.View", "Freezers.View"],
        hidden: true
      }
    ]
  },
  {
    path: "/reports/prescriptions",
    name: "Reporte de Recetas",
    mini: "RR",
    layout: "/admin",
    component: PrescriptionReportPage,
      hidden: false,
      permission: ["Agenda.Create"],
  },
  // Error Pages
  {
    path: "/unauthorized",
    name: "Error",
    layout: "/admin",
    component: UnauthorizedPage,
    hidden: true,
  },
  {
    path: "/forbidden",
    name: "Error",
    layout: "/admin",
    component: ForbiddenPage,
    hidden: true,
  },
  {
    path: "/not-found",
    name: "Error",
    layout: "/admin",
    component: NotFoundPage,
    hidden: true,
  },
  //Telemetry
  {
    path: "/devicetelemetry",
    name: "routes.telemetry",
    layout: "/admin",
    iconSVG: "telemetry",
    permission: ["Telemetry.View"],
    component: TelemetryPage
  },
];

export default routes;
